/* eslint-disable no-useless-catch */
/* eslint-disable no-else-return */
import axiosInstance from "../services/AxiosInstance";
import { store } from "../store/store";

const Service = {
  get: async (url) => {
    const state = store.getState();
    const token = state.auth.auth.token;
    try {
      const apiData = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      return apiData;
    } catch (error) {
      throw error;
    }
  },
  getWithoutToken: async (url) => {
    try {
      const apiData = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return apiData;
    } catch (error) {
      throw error;
    }
  },
  getWithParams: (url, key, value) => {
    const state = store.getState();
    const token = state.auth.auth.token;
    try {
      const apiData = axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        params: {
          [key]: value,
        },
      });

      return apiData;
    } catch (error) {
      throw error;
    }
  },
  post: (url, data) => {
    const state = store.getState();
    const token = state.auth.auth.token;
    const apiData = axiosInstance.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    });
    return apiData;
  },
  patch: (url, data) => {
    const state = store.getState();
    const token = state.auth.auth.token;
    const apiData = axiosInstance.patch(url, data, {
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    });
    return apiData;
  },
  getWithData: (url, data) => {
    const state = store.getState();
    const token = state.auth.auth.token;
    try {
      const apiData = axiosInstance.get(url, data, {
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      return apiData;
    } catch (error) {
      throw error;
    }
  },
  delete: (url) => {
    const state = store.getState();
    const token = state.auth.auth.token;
    const apiData = axiosInstance.delete(url, {
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    });
    return apiData;
  },
  deleteWithBody: (url, data) => {
    const state = store.getState();
    const token = state.auth.auth.token;
    const apiData = axiosInstance.delete(url, {
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      data,
    });
    return apiData;
  },
  put: (url, data) => {
    const state = store.getState();
    const token = state.auth.auth.token;
    const apiData = axiosInstance.put(url, data, {
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    });
    return apiData;
  },
  postWithFile: (url, data) =>
    axiosInstance.post(url, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  postTokenWithFile: (url, data) => {
    const token = "";
    return axiosInstance.post(url, data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
  },
  postToken: async (url, data) => {
    const token = "";
    return axiosInstance.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
      },
    });
  },
  updateLead: async (url, headers, data) =>
    axiosInstance({
      method: "put",
      url,
      headers,
      data,
    }),
  custom: async ({ url, method, headers, responseType, data }) =>
  {
    const state = store.getState();
    const token = state.auth.auth.token;
    let header = headers;

    if(token) {
      header.Authorization = `Bearer ${token}`;
    }
    return axiosInstance({
      method,
      url,
      headers: header,
      responseType,
      data,
    });
  }
};

export default Service;
